import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { LegalPage, legalDocumentFromUrl } from './legal/LegalPage.tsx';
import { GOOGLE_CALLBACK_PATH, GoogleCallback } from './login/GoogleCallback.tsx';
import { printTokenFromUrl } from './print/print-api.ts';
import { PrintReport } from './print/PrintReport.tsx';
import { SharedLink } from './share/SharedLink.tsx';
import { shareTokenFromUrl } from './share/public-share-api.ts';
import './styles.css';
import './reports/reports.css';
import './login/login.css';
import './portal/portal.css';
import './agency/agency.css';
import './agency/explore/explore.css';
import './kpis/kpis.css';
import './agency/rollups/rollups.css';
import './custom/custom.css';
import './whitelabel/whitelabel.css';
import './assistant/assistant.css';
import './assistant/drawer.css';
import './legal/legal.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// A share link (/s/<code>) and the PDF renderer's print page (/print/<code>)
// need no sign-in, so neither starts the app's session.
const shareToken = shareTokenFromUrl();
const legalDocument = legalDocumentFromUrl();
const printToken = printTokenFromUrl();

function Root() {
  if (window.location.pathname === GOOGLE_CALLBACK_PATH) return <GoogleCallback />;
  if (printToken) return <PrintReport token={printToken} />;
  if (legalDocument) return <LegalPage document={legalDocument} />;
  if (shareToken) return <SharedLink token={shareToken} />;
  return <App />;
}

createRoot(root).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
